var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgUltrasound = function SvgUltrasound(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 108 108",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".ultrasound{fill:none;stroke:#f9f9fa;stroke-linecap:round;stroke-linejoin:round;stroke-width:3px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ultrasound"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ultrasound",
    d: "M41.66,79.37s-5.34-.89-5.34-10.69c0-6.23,5.3-10.79,6.23-15.14,2.68-12.48-1.78-26.73-1.78-26.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ultrasound",
    d: "M60.37,52.65c-1.54,0-2.79,1.46-3.56,2.67-.77-1.21-2-2.67-3.57-2.67a4.54,4.54,0,0,0-4.45,4.45c0,5.62,8,9.8,8,9.8s8-4.18,8-9.8A4.54,4.54,0,0,0,60.37,52.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ultrasound",
    d: "M52.35,73.14s17.82,0,17.82-15.15c0-10.69-7.87-17.65-7.87-17.65"
  }), /*#__PURE__*/React.createElement("line", {
    className: "ultrasound",
    x1: 55.03,
    y1: 79.37,
    x2: 55.92,
    y2: 73.14
  }), /*#__PURE__*/React.createElement("path", {
    className: "ultrasound",
    d: "M55.92,26.81l9.35,6.8a1,1,0,0,1,.42.91c-.09,1.08-.42,3.42-1.76,4.76-2.67,2.68-7.12.89-7.12.89"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUltrasound, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ultrasound.0520bacc.svg";
export { ForwardRef as ReactComponent };